import router from "@/router";
import headful from "headful";
import Config from "@/config";
import storage from "@/utils/storage";
import {end} from "@/utils/string";
import {
    contextFirstVisibleTask, groupById, TABS
} from "@/utils/task";
import Vue from "vue";
import {pickIsSearch} from "@/utils/pick";
import store from "@/store";

const mutations = {

    uiValidateRoute: async (state, {to, from}) => {
        console.log("VALIDATING ROUTE....");

        // should no open together context and task that does not belong to it
        let redirect = null;
        const myRoute = {name: "my"};
        const picks = state.session.area.picks;
        const topics = state.session.area.topics;
        const groups = state.session.area.groups;
        const users = state.session.area.users;
        const context = state.page.context;
        const tasks = state.page.tasks.items;
        const task = state.page.task.item;
        const totalTasks = state.session.totalTasks;
        const isAnon = state.session.isAnon;

        //console.log("context topic", context.topic);
        /*if (isAnon) {
            redirect = {
                name: "auth"
            }
        } else */
        if (to.name === "home" || to.name === "1task-start") {
            console.log("1task-start 1 totalTasks: " + totalTasks);
            if (task?.id) {
                redirect = {
                    name: '1task',
                    params: {taskId: task.id}
                };
            }/* else if ( !isAnon ) {
                redirect = {
                    name: 'home',
                };
            } */ else if (isAnon) {
                redirect = {
                    name: 'auth',
                };
            } else if (to.name === "1task-start") {
                console.log("1task-start 2: " + totalTasks);
                if (totalTasks) {
                    // we are at 1task mode and we do not have any UNDONE task - go to done page
                    redirect = {
                        name: '1task-done',
                    };
                } else {
                    // we are at 1task mode and we do not have any task AT ALL - go to home page
                    redirect = {
                        name: 'home',
                    };
                }
            } else {
                // we are at home page and we do not have any task - just force context menu
                state.ui.withContextList = true;
            }
        } else if (to.name === "context") {
            // отключено: контекст-задачу с деталями/комментариями больше не открываем сразу с панелью задачи
            // (кроме возврата из панели кнопкой/закрытием - там params.noAutoPanel)
            /*if (context.withTaskPanelRecommended && context.item?.id && !to.params?.noAutoPanel) {
                const chain = [...(context.parents?.map(el => el.id) || []), context.item.id];
                redirect = {
                    name: "context-task",
                    params: {
                        contextId: chain.join(Config.CONTEXT_ID_CHAIN_SEP),
                        taskId: context.item.id,
                        skipContext: true,
                    },
                    query: to.query,
                };
            }*/
            // убрано в новой концепции топиков-задач
            /*if (context.item?.is1Task || context.item?.isBlock) {
                // redirect to first task of context
                redirect = routeForContextFirstVisibleTask();
                // context is already here so we set withContext=false
                if ( redirect ) redirect.params.skipContext = true;
                else {
                    // redirect to any first task, even inactive
                    redirect = routeForContextFirstTask();
                }
            }*/
        } else if (to.name === "context-task") {
            if (isAnon) redirect = {
                // route to task without context
                name: 'task',
                params: {taskId: task.id}
            };
            //if (state.session.currentTask?.item?.id && state.session.currentTask?.item?.id === state.page.task?.item?.id) {
            /*if (state.page.task.timer) {
                //console.log("There is a current task");
                state.ui.isTaskFullscreen = true;
            }*/
        } else if (to.name === "new") {
            const task = state.page.taskAppend?.item;
            if (task?.id) {
                /*const group = groupById(task.groupId);
                if (group) {
                    redirect = {
                        name: 'context-task',
                        params: {contextId: group.contextId, taskId: task.id}
                    };
                }*/
                redirect = {
                    name: 'task',
                    params: {taskId: task.id}
                };
            }
        }
        // invalid topic/group
        /*if (context.topic?.id && task.topicId !== context.topic?.id) redirect = {
            name: "topic-task",
            params: {topicAuth: context.topic.auth, taskId: task.auth}
        };
        else if (context.group?.id && task.groupId !== context.group?.id) redirect = {
            name: "group-task",
            params: {groupAuth: context.group.auth, taskId: task.auth}
        };*/

        if (redirect) {
            console.log("REDIRECT ON INVALID ROUTE " + to.name, redirect);
            state.ui.isValidRoute = false;
            router.push(redirect);
            return;
        }
        console.log("VALID ROUTE " + to.name, to.params);
        state.ui.isFirstLoad = false;
        state.ui.isValidRoute = true;
    },

    /**
     * Called BEFORE each routing.
     * @param state
     * @param to
     * @param from
     */
    uiInitBeforeRouting: (state, {to, from}) => {
        state.ui.isRouting = true;

        mutations.uiClearPageBeforeRouting(state, {to, from});

        let timeout = 0;
        if (to && state.isMD) timeout = Config.ROUTING_FADE_IN_TIME;
        setTimeout(() => {
            if (to.meta?.isTaskFullscreen) {
                state.ui.isTaskFullscreen = true;
            } else {
                state.ui.isTaskFullscreen = false;
            }

            console.log("to.query", to.query);

            if (to.query?.ai) {
                state.ui.isTaskWithAIChat = true;
            } else {
                state.ui.isTaskWithAIChat = false;
            }
        }, timeout);
    },
    /**
     * Called AFTER each routing, data is fetched, route is validated.
     * @param state
     * @param to
     * @param from
     */
    uiInitAfterRouting: (state, {to, from}) => {
        mutations.uiClearPageAfterRouting(state, {to, from});
    },

    /**
     * This mutation is called BEFORE routing.
     * Clear needed ui element states here.
     * @param state
     * @param payload
     */
    uiClearPageBeforeRouting: (state, {to, from}) => {
        console.log("uiClearPageBeforeRouting();");

        state.ui.isRouting = true;
        if (!to.params?.apiless) state.lastError = null;

        // mark the task we're navigating to as pending - task-editor2 clears this once it has
        // something to show for the new task (its own content preview), not once routing settles
        // NOTE: resolve the task id via taskId - different route flavors (e.g.
        // fullscreen "task" vs "context-task") may differ even for the same task,
        // so comparing raw params would wrongly treat a flavor switch as navigating to a new task
        const toTaskId = to.params?.taskId;
        const fromTaskId = from.params?.taskId;
        if (toTaskId) {
            if (toTaskId !== fromTaskId) state.ui.pending.taskId = toTaskId;
        } else {
            state.ui.pending.taskId = null;
        }
        /*if ( !state.isMD && to.name !== "1task-start") {
            state.ui.withContextList = false;
        }*/

        //const context = state.page.context.item;
        //const isNowSearchContext = pickIsSearch(context);
        //console.log("isNowSearchContext", isNowSearchContext, to.params.isSearch);

        //if ( !to.params?.taskId) state.ui.isTaskFullscreen = false;

        if (
            !(to.params?.contextId && from.params?.contextId && to.params?.contextId === from.params.contextId)
            //&& !(isNowSearchContext && to.params?.isSearch)
        ) {
            // navigating between different contexts

            state.page.tasks.isInited = false;
            //state.page.task.isInited = false;
            //state.page.context.tab = TABS.ACTUAL;
            //state.ui.shouldSortTasks = true;
        }
            //else if (to.params?.taskId && from.params?.taskId && to.params?.taskId !== from.params.taskId) {
        /*else if (from.params?.taskId) {
            //console.log("ui clear task");
            state.page.task.isInited = false;
            state.ui.isMsgEditorExpanded = false;
            state.ui.isTaskEditorExpanded = false;

            mutations.uiClearMsg(state);
        }*/
        else if (to.params?.taskId) {
            // navigating to a task

            /*     if ( state.page.task.item ) {
                     state.page.task.item.stage = null;
                     state.page.task.item.content = null;
                 }*/

            if (to.params?.taskId !== from.params?.taskId) {
                state.page.task.isInited = false;
                state.ui.isMsgEditorExpanded = false;
                state.ui.isTaskEditorExpanded = false;
                mutations.uiClearMsg(state);
            }
        }

        /*        // some page specifics
                if (to.name === "home" && !from.name) {
                    console.log("FIRST NAV");
                    state.ui.isUIHidden = true;
                }*/

        //Vue.set(state.page.context, "selectedTasks",  []);

        /*if (to.name !== "search" && to.name !== "search-task") {
            //this.commit("uiClearTask");
            state.ui.search.value = null;
        }*/
    },
    /**
     * This mutation is called AFTER routing.
     * Clear needed ui element states here.
     * @param state
     * @param payload
     */
    uiClearPageAfterRouting: (state, {to, from}) => {
        //console.log("uiClearPageAfterRouting()", to, from);
        //state.ui.search.value = null;
        state.ui.search.isSearching = false;

        if (state.ui.routingInstructions.shouldMaximizeComments) {
            state.ui.withMaximizedComments = true;
            state.ui.routingInstructions.shouldMaximizeComments = false;
        } else if (state.ui.routingInstructions.shouldMinimizeComments) {
            state.ui.withMaximizedComments = false;
            state.ui.routingInstructions.shouldMinimizeComments = false;
        } else {
            if (state.isMD) state.ui.withMaximizedComments = null;  // on MD+ we start with similar preference
            else state.ui.withMaximizedComments = false;  // on XS,SM we start with editor preference
        }

        /*if ( state.ui.isTaskFullscreen && !to.meta?.isTaskFullscreen) {
            //if ( state.page.task.item?.id !== state.session.currentTask.item?.id ) state.ui.isTaskFullscreen = false;
            if ( !state.page.task.timer ) state.ui.isTaskFullscreen = false;
            //if ( !state.page.task.timer) state.ui.isTaskFullscreen = false;
        }*/

        /*if ( from.name === "context-task"  && to.name !== "context-task" ) {
            console.log("WE LEFT task route!", from);
            // we have left task route
            state.page.task.item = null;
        }*/

        // clear all pending items
        // small pause to make things smoother
        setTimeout(() => {
            state.ui.pending.context = null;
            state.ui.pending.editor = null;
            state.ui.pending.tab = null;
            // NOTE: pending.taskId is intentionally NOT cleared here - it now stays set until
            // task-editor2 confirms it has something to show for the task

            if (!state.isMD && to.name !== "1task-start") {
                setTimeout(() => {
                    state.ui.withContextList = false;
                }, 50);
            }
        }, 25);

        // these clearings are applied after all components have checked their logic against routingInstructions
        setTimeout(() => {
            state.ui.routingInstructions.isOpeningNewTask = false;
            state.ui.isRouting = false; // a little bigger pause for nice timer changes
        }, 300);
    },
    uiClearMsg: (state, payload) => {
        state.page.comment.item.id = null;
        state.page.comment.item.content = null;
        state.page.comment.item.action = null;
        //state.page.comment.uploads = null;
        Vue.set(state.page.comment, "uploads", null);
    },
    uiClearSearchWithContexts: (state, payload) => {
        state.ui.search.withContexts = false;
    },

    uiToggleContextList: (state, payload) => {
        state.ui.withContextList = !state.ui.withContextList;
    },
    uiSetWithContextList: (state, payload) => {
        state.ui.withContextList = payload;
    },
    uiSetWithArchivedGroups: (state, payload) => {
        state.ui.withArchivedGroups = payload;
    },
    uiToggleUserListMode: (state, payload) => {
        mutations.uiSetIsUserListMode(state, !state.ui.isUserListMode);
    },
    uiSetIsUserListMode: (state, payload) => {
        //console.log("uiSetIsUserListMode", payload);
        state.ui.isUserListMode = !!payload;
        storage.set(Config.STORAGE_USER_LIST_MODE, state.ui.isUserListMode);
    },
    uiToggleWithHiddenTasks: (state, payload) => {
        mutations.uiSetWithHiddenTasks(state, !state.ui.withHiddenTasks);
    },
    uiSetWithHiddenTasks: (state, payload) => {
        state.ui.withHiddenTasks = !!payload;
        storage.set(Config.STORAGE_SHOW_HIDDEN_TASKS, state.ui.withHiddenTasks);
    },
    uiSetHiddenParagraphsCount: (state, payload) => {
        state.ui.hiddenParagraphsCount = payload || 0;
    },
    uiSetIsUserContextTree: (state, payload) => {
        state.ui.isUserContextTree = !!payload;
        storage.set(Config.STORAGE_USER_CONTEXT_TREE, state.ui.isUserContextTree);
    },
    uiSetIsTextTaskList: (state, payload) => {
        state.ui.isTextTaskList = !!payload;
        storage.setSession(Config.STORAGE_TEXT_TASK_LIST, state.ui.isTextTaskList);
    },
    uiToggleIsAiChatDebugMode: (state, payload) => {
        mutations.uiSetIsAiChatDebugMode(state, !state.ui.isAiChatDebugMode);
    },
    uiSetIsAiChatDebugMode: (state, payload) => {
        state.ui.isAiChatDebugMode = !!payload;
        storage.set(Config.STORAGE_AI_CHAT_DEBUG_MODE, state.ui.isAiChatDebugMode);
    },
    uiSetWithTaskDropZones: (state, payload) => {
        state.ui.withTaskDropZones = !!payload;
    },
    /**
     * Оптимистичный swap цели процесса: пока backend выполняет swapProcessGoal, список шагов показывает
     * бывшую цель в новой позиции (с индикатором загрузки), а последний назначаемый шаг - как новую цель.
     * Вызывается до запроса; payload = {processId, index}, null - сбросить (успех или ошибка).
     */
    uiSetPendingGoalSwap: (state, payload) => {
        state.ui.pendingGoalSwap = payload || null;
    },
    uiSetDraggedGoal: (state, payload) => {
        state.ui.draggedGoal = payload || null;
    },
    uiSetWithStageDropZones: (state, payload) => {
        state.ui.withStageDropZones = !!payload;
    },
    uiSetWithOpenSubtasks: (state, payload) => {
        state.ui.withOpenSubtasks = payload;
        /*if (state.ui.withOpenSubtasks) {
            mutations.uiSetWithMaximizedComments(state, false);
        }*/
    },
    uiSetWithMaximizedComments: (state, payload) => {
        state.ui.withMaximizedComments = payload;
        if (state.ui.withMaximizedComments === true) {
            mutations.uiSetWithOpenSubtasks(state, false);
        } else {
            if (state.ui.isMsgEditorExpanded) {
                mutations.uiExtendMsgEditor(state, false);
            }
        }
    },
    uiSetRoutingInstructions: (state, payload) => {
        if (!payload) return;
        Object.keys(payload).forEach(key => {
            state.ui.routingInstructions[key] = payload[key];
        });
    },
    uiExtendMsgEditor: (state, payload) => {
        state.ui.isMsgEditorExpanded = payload;
        if (!store.getters.isWindowMD) {
            if (state.ui.isMsgEditorExpanded) {
                mutations.uiSetWithMaximizedComments(state, true);
            }
        }
    },
    uiExpandTaskEditor: (state, payload) => {
        state.ui.isTaskEditorExpanded = payload;
    },
    /**
     * Помечает контент как улучшаемый через AI (или снимает пометку) - task-editor2 на это время блокирует ввод.
     * @param payload {{contentId: string, value: boolean}}
     */
    uiSetAIImproving: (state, payload) => {
        if (payload.value) Vue.set(state.ui.aiImprovingContentIds, payload.contentId, true);
        else Vue.delete(state.ui.aiImprovingContentIds, payload.contentId);
    },
    /**
     * Запускает на редакторе одноразовую анимацию "текст улучшен" (класс --ai-improved) и сам её снимает.
     * @param payload {{contentId: string}}
     */
    uiFlashAIImproved: (state, payload) => {
        Vue.set(state.ui.aiImprovedContentIds, payload.contentId, true);
        setTimeout(() => Vue.delete(state.ui.aiImprovedContentIds, payload.contentId), 1300);
    },
    uiSetTaskFullscreen: (state, payload) => {
        console.log("uiSetTaskFullscreen", payload);
        state.ui.isTaskFullscreen = payload;
    },
    uiSetTaskWithAIChat: (state, payload) => {
        console.log("uiSetTaskWithAIChat", payload);
        state.ui.isTaskWithAIChat = payload;
    },
    uiSetDragged: (state, payload) => {
        state.ui.dragged = payload;
    },
    uiSetSearch: (state, payload) => {
        //console.log("uiSetSearch", payload);
        storage.set(Config.STORAGE_GROUP_SEARCH, state.ui.search.value);
        state.ui.search.value = payload;
    },
    uiSetIsSearching: (state, payload) => {
        if (payload) {
            storage.set(Config.STORAGE_GROUP_SEARCH, state.ui.search.value);
            //state.ui.search.value = payload;
            state.ui.search.isSearching = true;
        } else state.ui.search.isSearching = false;
    },
    uiSetPendingTaskId: (state, payload) => {
        state.ui.pending.taskId = payload;
        //console.log("PENDING TASK ID SET TO ", payload);
    },
    uiSetPendingContext: (state, payload) => {
        state.ui.pending.context = payload;
    },
    uiSetPendingEditor: (state, payload) => {
        state.ui.pending.editor = payload;
    },
    uiSetPendingTab: (state, payload) => {
        state.ui.pending.tab = payload;
    },
    /*uiSetShouldSortTasks: (state, payload) => {
        state.ui.shouldSortTasks = payload;
    },*/
    uiMenu: (state, payload) => {
        //console.log("ITEM MENU MUTATION!", payload);

        if (!payload.menu) return;
        //if (!payload.params) return;

        const menu = payload.menu;

        let timeout = 0;
        if (menu.isVisible) {
            menu.isVisible = false;
            timeout = 150;

            if (menu.item === payload.params?.item) {
                setTimeout(() => {
                    menu.item = null;
                }, timeout);
                return;
            }
        }

        setTimeout(() => {
            Object.keys(menu).forEach(key => menu[key] = null);
            menu.isVisible = true;

            //console.log("isVisible!!");

            if (payload.params) {
                menu.callback = payload.params.callback;
                //menu.item = payload.params.item;
                menu.x = payload.params.event?.clientX;
                menu.y = payload.params.event?.clientY + 16;

                //console.log("PARAMS!!", payload.params);
                Object.keys(payload.params).forEach(key => menu[key] = payload.params[key]);
            }

        }, timeout);
    },
    uiHide: (state, payload) => {
        console.log("HIDE!", payload);

        const ui = state.ui;
        if (ui[payload]?.isVisible) ui[payload].isVisible = false;
    },
    uiSetContextTasksFilterProperty: (state, payload) => {
        console.log("uiSetContextTasksFilterProperty", payload);
        if (typeof payload != "object") return;
        const contextId = state.page.context.item?.id;
        if (!contextId) return;
        const value = state.ui.contextTasksFilter;//storage.get(Config.STORAGE_CONTEXT_TASKS_FILTER) || {};
        let c = value[contextId];//.find(el=>el.contextId === contextId);
        if (!c) c = value[contextId] = {};
        Object.keys(payload).forEach(key => {
            c[key] = payload[key];
            //state.ui.contextTasksFilter[key] = value[key] || null;
        });
        c.updatedAt = new Date().valueOf();
        //console.log("storing", value);
        storage.set(Config.STORAGE_CONTEXT_TASKS_FILTER, value);
    },
    uiClearContextTasksFilter: (state, payload) => {
        const value = {};
        Object.keys(state.ui.contextTasksFilter).forEach(key => {
            state.ui.contextTasksFilter[key] = null;
        });
        storage.set(Config.STORAGE_CONTEXT_TASKS_FILTER, value);
    },
    /**
     * @deprecated
     * @param state
     * @param payload
     */
    uiSetVisibleContextFilter: (state, payload) => {
        state.ui.visibleContextFilter = payload;
    },
    uiSetContextFilterAssigneeId: (state, payload) => {
        console.log("uiSetContextFilterAssigneeId", payload);
        Vue.set(state.page.context, "filterAssigneeId", payload);
    },
    uiSetContextFilterColor: (state, payload) => {
        console.log("uiSetContextFilterColor", payload);
        Vue.set(state.page.context, "filterColor", payload);
    },
    uiSetContext1Task: (state, payload) => {
        console.log("uiContextMode", payload);

        const groupAuth = payload.groupAuth;
        const topicAuth = payload.topicAuth;
        const tagAuth = payload.tagAuth;

        let context;
        if (tagAuth) {
            context = state.session.area.tags?.find(el => el.auth === tagAuth);
        } else if (topicAuth) {
            context = state.session.area.topics?.find(el => el.auth === topicAuth);
        } else if (groupAuth) {
            context = state.session.area.groups?.find(el => el.auth === groupAuth);
        }
        if (!context) return;

        state.ui.isContext1TaskMode = payload?.isOn;
    },

    uiSetNavPath: (state, payload) => {
        state.ui.navPath = payload;
    },
    uiSetTitle: (state, source) => {
        //console.log("uiSetTitle", source);
        let title = Config.DEFAULT_TITLE;
        if (typeof source === "string") {
            title = source;
        } else if (typeof source === "object") {
            if (typeof source.to?.meta?.title === "function") {
                title = source.to.meta.title();
            } else if (typeof source.to?.meta?.title === "string") {
                title = source.to.meta.title;
            }
        }

        headful({
            title,
        });
    },

    uiDialogFilesViewer: (state, payload) => {
        if (!payload?.files?.length) return;

        return new Promise((resolve, reject) => {
            console.log("dialogFilesViewer", payload);
            state.ui.dialogFilesViewer.files = payload.files;
            state.ui.dialogFilesViewer.index = payload.index || 0;
            //state.ui.dialogFilesViewer.callback = payload.callback;
            state.ui.dialogFilesViewer.isVisible = true;
        });
    },
    uiDialogCommentsViewer: (state, payload) => {
        if (!state.page.task.children?.length) return;

        return new Promise((resolve, reject) => {
            console.log("dialogCommentsViewer", payload);
            state.ui.dialogCommentsViewer.parent = payload.parent;
            state.ui.dialogCommentsViewer.items = payload.items;
            state.ui.dialogCommentsViewer.index = payload.index;
            state.ui.dialogCommentsViewer.isVisible = true;
        });
    },

    uiSetActorOfGroupTaskSort: (state, payload) => {
        mutations.uiSetActor(state, {
            mutation: state.ui.mutations.groupTaskSort,
            ...payload
        });
    },
    uiSetActorOfTask: (state, payload) => {
        mutations.uiSetActor(state, {
            mutation: state.ui.mutations.task,
            ...payload
        });
    },
    uiSetActorOfGroup: (state, payload) => {
        mutations.uiSetActor(state, {
            mutation: state.ui.mutations.group,
            ...payload
        });
    },
    uiSetActor: (state, payload) => {
        //console.log("SETTING ACTOR", payload);
        clearTimeout(payload.mutation.timeout);
        payload.mutation.userAuth = payload.userAuth;
        payload.mutation.subjectAuth = payload.subjectAuth;
        payload.mutation.icon = payload.icon;
        payload.mutation.timeout = setTimeout(() => {
            payload.mutation.userAuth = null;
        }, payload.timeout || 600);
    },

    uiSetTaskNumbers: (state, payload) => {
        Vue.set(state.page.task, "numbers", payload);
    },

    uiRouteToTab: (state, payload) => {
        // skip routing if we are here
        if (state.page.context.tab === payload) return;

        let query = {...router.currentRoute.query, tab: payload};
        state.page.context.tab = payload;
        state.ui.pending.tab = payload;
        //this.$store.commit("uiSetPendingTab", tabItem.id);

        //console.log("routing... for TAB", payload, router.currentRoute.params, query);
        router.push({
            name: router.currentRoute.name,
            params: {...router.currentRoute.params, skipContext: false, apiless: false},	// force api request
            query
        });
    },
    uiSetTab: (state, payload) => {
        state.page.context.tab = payload;
    },
    uiRedirect: (state, payload) => {
        console.log("uiRedirect", payload);

    },
    uiError: (state, payload) => {
        //console.log("uiError", payload);

        const error = state.ui.error;

        error.isVisible = true;
        error.message = payload.message;
        error.code = payload.code;
    },

    uiStoreIdInList: (state, payload) => {
        //console.log("uiError", payload);

        const key = payload.key;
        let v = storage.get(key);
        if (!Array.isArray(v)) v = [];
        if (payload.value) {
            // append
            if (!v.includes(payload.id)) v.push(payload.id);
        } else {
            // remove
            const i = v.findIndex(el => el === payload.id);
            if (i >= 0) v.splice(i, 1);
        }
        storage.set(key, v);
        //console.log("SET "+payload.key, v);
    },


    /**
     * @param state
     * @param payload - array of disabled tab ids.
     */
    uiSetSearchExcludedTabs: (state, payload) => {
        //console.log("uiSetSearchExcludedTabs", payload);
        Vue.set(state.ui.search, "excludedTabs", payload);
        storage.set(Config.STORAGE_SEARCH_DISABLED_TABS, payload);
        /*payload?.forEach(id => {
            if (id) mutations.uiStoreIdInList(state, {
                key: Config.STORAGE_SEARCH_DISABLED_TABS,
                id,
                value: true
            });
        });*/
    },
    uiSetSearchIncludedTabs: (state, payload) => {
        //console.log("uiSetSearchIncludedTabs", payload);
        Vue.set(state.ui.search, "includedTabs", payload);
        //storage.set(Config.STORAGE_SEARCH_DISABLED_TABS, payload);
        /*payload?.forEach(id => {
            if (id) mutations.uiStoreIdInList(state, {
                key: Config.STORAGE_SEARCH_DISABLED_TABS,
                id,
                value: true
            });
        });*/
    },
    uiSetSearchGroupIds: (state, payload) => {
        //console.log("uiSetSearchGroupIds", payload);
        Vue.set(state.ui.search, "groupIds", payload);
        storage.set(Config.STORAGE_SEARCH_GROUP_IDS, payload);
        /*payload?.forEach(id => {
            if (id) mutations.uiStoreIdInList(state, {
                key: Config.STORAGE_SEARCH_GROUP_IDS,
                id,
                value: true
            });
        });*/
    },
    uiToggleSearchWithContexts: (state, payload) => {
        Vue.set(state.ui.search, "withContexts", !state.ui.search.withContexts);
    }

};

export default mutations;
